import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { SYSTEM_ADMIN_PATH } from '../../../../constants';
import { fetchAdminOrganizationDetailRequest } from './Organization/actions';
const Organizations = React.lazy(() => import('./index'));
const OrganizationsDetail = React.lazy(() => import('./Organization/Details'));

const GetOrganizationsDetails = ({ match }) => {
     const dispatch = useDispatch();
     const organization = useSelector((state) => state.admin.organization);
     const organizationId = match.params.id;

     const fetchData = () => {
          if (!organization || organization.id !== organizationId) {
               dispatch(fetchAdminOrganizationDetailRequest(organizationId));
          }
     };

     useEffect(fetchData, []); // eslint-disable-line react-hooks/exhaustive-deps

     const orgName = organization?.name || '';

     return <span>{orgName}</span>;
};

const Routes = {
     path: SYSTEM_ADMIN_PATH.ORGANIZATIONS,
     breadcrumb: 'Organizations',
     element: <Outlet />,
     children: [
          { index: true, element: <Organizations /> },
          {
               path: SYSTEM_ADMIN_PATH.ORGANIZATIONS_DETAILS,
               breadcrumb: GetOrganizationsDetails,
               element: <OrganizationsDetail />,
          },
     ],
};

export default Routes;
